module.exports = __webpack_public_path__ + "static/media/2024pca.f04abedc.png";